import { render, staticRenderFns } from "./OrderStatusBadge.vue?vue&type=template&id=fd028d50&scoped=true&"
import script from "./OrderStatusBadge.vue?vue&type=script&lang=js&"
export * from "./OrderStatusBadge.vue?vue&type=script&lang=js&"
import style0 from "./OrderStatusBadge.vue?vue&type=style&index=0&id=fd028d50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd028d50",
  null
  
)

export default component.exports